import React from "react";
import { useSelector } from "react-redux";
import {
    ListItem,
    ListItemText,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material/";

import { strings } from "../../../common/i18n";
import styles from "../styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
/**
 * Left Panel  Exclusion Reasons
 */
export default ({
    exclusionReason,
    note,
    onChange,
    identifiers,
    validList,
    selectedDate,
    handleDateChange,
    isExclusionDatePicker
}) => {
    const { typesList } = useSelector((state) => state);

    return (
        <>
            <FormControl
                fullWidth
                sx={styles.formControl}
                margin="normal"
                variant="outlined"
            >
                <InputLabel>{strings("exclusionReason")}</InputLabel>
                <Select
                    label={strings("exclusionReason")}
                    onChange={onChange("exclusionReason")}
                    value={exclusionReason || ""}
                >
                    {typesList.exclusionReasonTypes.data.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl
                fullWidth
                sx={styles.formControl}
                margin="normal"
                variant="outlined"
            >
                {/*Sold Date Picker only for exclusion reason (Asset is sold) */}

                {isExclusionDatePicker && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            disableFuture
                            label={strings("soldDate")}
                            value={selectedDate}
                            onChange={handleDateChange}
                            renderInput={(props) => (
                                <TextField {...props} fullWidth />
                            )}
                        />
                    </LocalizationProvider>
                )}
                <TextField
                    fullWidth
                    margin="normal"
                    multiline
                    onChange={onChange("note")}
                    placeholder={strings("messages.enterNote")}
                    minRows={4}
                    value={note}
                    variant="outlined"
                />
            </FormControl>
            {/* Displaying (Valid/Invlaid) vin lengths */}
            {identifiers.length > 0 &&
                Object.keys(validList).map((item) => (
                    <ListItem key={item} sx={{ py: 0 }}>
                        <ListItemText
                            secondary={`${strings(item)} - ${validList[item]}`}
                        />
                    </ListItem>
                ))}
        </>
    );
};
